<template>
  <AddEditAttendeeDialog
    :guestsAllowed="guestsAllowed"
    :attendee="attendeeWithFullname"
    :guests="attendee.guests_count"
    :response="reply"
    :view-context="viewContext"
    @save="handleEdit($event)"
    @delete="$emit('delete', attendee.personal_record_id)"
  >
    <template v-slot="{ click, attrs }">
      <AvatarCard
        @edit="click"
        :subtitle="!!attendee.guests_count"
        :name="attendee.name"
        :url="attendee.url"
        :is-editable="isEditable"
        :email="attendee.email"
        :avatarUrl="attendee.avatar_url"
        max-width="100%"
      >
        <template v-slot:subtitle v-if="attendee.guests_count">
          <v-icon class="mr-1" :size="18">
            {{ guestsIcon }}
          </v-icon>
          {{ attendee.guests_count }}
          {{ attendeeGuestsText(attendee.guests_count) }}
        </template>
      </AvatarCard>
    </template>
  </AddEditAttendeeDialog>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { Rsvp, RsvpReply } from "suus-api"
import AvatarCard from "components/UI/AvatarCard.vue"
import { mdiAccountMultipleOutline } from "@mdi/js"
import useTranslate from "features/common/translate/concerns/useTranslate"
import AddEditAttendeeDialog, {
  AddEditAttendee,
} from "features/events/attendees/add-edit-attendee/AddEditAttendeeDialog.vue"
import { ViewContext } from "concerns/useContextName"

export default defineComponent({
  name: "EventAvatarCard",
  components: { AddEditAttendeeDialog, AvatarCard },
  props: {
    attendee: {
      type: Object as () => Rsvp,
      required: true,
    },
    reply: String as PropType<RsvpReply>,
    isEditable: Boolean,
    guestsAllowed: Boolean,
    viewContext: Object as PropType<ViewContext>,
  },
  computed: {
    attendeeWithFullname(): Rsvp & { full_name: string } {
      return { ...this.attendee, full_name: this.attendee.name }
    },
  },
  methods: {
    attendeeGuestsText(attendeeCount: number) {
      return this.tc("guest", attendeeCount)
    },
    handleEdit(saveObject: AddEditAttendee) {
      this.$emit("edit", saveObject)
    },
  },
  setup() {
    const { tc } = useTranslate("components.attendee_list")

    return {
      guestsIcon: mdiAccountMultipleOutline,
      tc,
    }
  },
})
</script>
